import { Component, inject, Input, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { OfferMetadata } from '@app/resources/services';
import { CurrencyPipe } from '@angular/common';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-offer-analytics-card',
  templateUrl: './offer-analytics-card.component.html',
  styleUrls: ['./offer-analytics-card.component.scss'],
  standalone: true,
  imports: [CardModule, CurrencyPipe],
})
export class OfferAnalyticsCardComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  @Input() offerMetadata: OfferMetadata = {
    NumberOfTextsSent: 0,
    PercentUsed: 0,
    OfferRevenue: 0,
    AverageSpend: 0,
  };
  @Input() theme: PortalTheme | undefined;

  ngOnInit(): void {
    this.setCSSCustomProperties();
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      document.documentElement.style.setProperty(
        '--form-header-bg-primary',
        this.theme.form.header?.primaryBackgroundColor
      );
      document.documentElement.style.setProperty('--form-header-text-color', this.theme.form?.header?.textColor);
      document.documentElement.style.setProperty('--form-bg-color', this.theme.form?.backgroundColor);
      document.documentElement.style.setProperty('--text--color-default', this.theme.defaultTextColor);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('OfferAnalyticsCardComponent');
    }
  }
}
